import {
  TIPO_FLUJO_TESORERIA,
  TipoFlujoTesoreriaType,
} from "api/Types/TipoFlujoTesoreria"
import { frontendCurrency } from "utils/formatCurrency"

interface RemesaColoredNumberProps {
  type?: TipoFlujoTesoreriaType
  number: number
}

export const RemesaColoredNumber = ({
  type,
  number,
}: RemesaColoredNumberProps) => {
  const signedNumber =
    type === TIPO_FLUJO_TESORERIA.COBRO
      ? Math.abs(number)
      : Math.abs(number) * -1

  return (
    <span
      className={
        type === TIPO_FLUJO_TESORERIA.COBRO
          ? "tw-text-secondary"
          : "tw-text-danger"
      }
    >
      {frontendCurrency(signedNumber)}
    </span>
  )
}
